/* tslint:disable */
/* eslint-disable */
/**
 * Lemonway DirectKit API 2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateAccountStatusInput
 */
export interface UpdateAccountStatusInput {
    /**
     * New payment account status<br/>0 = Unknown.<br/>1 = Not Opened.<br/>2 = Opened, need more documents.<br/>3 = Opened, document rejected.<br/>5 = Opened, KYC1.<br/>6 = Opened, KYC2.<br/>7 = Opened, KYC3.<br/>8 = Opened, document expired.<br/>9 = Frozen (by backoffice).<br/>10 = Blocked.<br/>11 = Locked (by Web Service).<br/>12 = Closed.<br/>13 = Pending KYC3.<br/>14 = One-time customer.<br/>15 = CGE.<br/>16 = Technical Payment Account.<br/>
     * @type {number}
     * @memberof UpdateAccountStatusInput
     */
    status: UpdateAccountStatusInputStatusEnum;
}


/**
 * @export
 */
export const UpdateAccountStatusInputStatusEnum = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3,
    NUMBER_5: 5,
    NUMBER_6: 6,
    NUMBER_7: 7,
    NUMBER_8: 8,
    NUMBER_9: 9,
    NUMBER_10: 10,
    NUMBER_11: 11,
    NUMBER_12: 12,
    NUMBER_13: 13,
    NUMBER_14: 14,
    NUMBER_15: 15,
    NUMBER_16: 16
} as const;
export type UpdateAccountStatusInputStatusEnum = typeof UpdateAccountStatusInputStatusEnum[keyof typeof UpdateAccountStatusInputStatusEnum];


/**
 * Check if a given object implements the UpdateAccountStatusInput interface.
 */
export function instanceOfUpdateAccountStatusInput(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "status" in value;

    return isInstance;
}

export function UpdateAccountStatusInputFromJSON(json: any): UpdateAccountStatusInput {
    return UpdateAccountStatusInputFromJSONTyped(json, false);
}

export function UpdateAccountStatusInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateAccountStatusInput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
    };
}

export function UpdateAccountStatusInputToJSON(value?: UpdateAccountStatusInput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
    };
}

